import EndpointService from '../services/EndpointService';
import Common from './common'
import Vue from 'vue'
import _ from 'lodash'

function buildAccessGroupsSummary(accessGroups) {
    if (!accessGroups || _.isEmpty(accessGroups)) {
      return ''
    }

    let validAccessGroups = _.filter(accessGroups, {deleted: false})
    if (_.isEmpty(validAccessGroups)) {
        return ''
      }

    return _.head(validAccessGroups).name + ((validAccessGroups.length > 1) ? ' and ' + (validAccessGroups.length - 1) + ' more' : '')
}
function buildAccessGroupsString(accessGroups) {
    if (!accessGroups || _.isEmpty(accessGroups)) {
      return ''
    }

    let validAccessGroups = _.filter(accessGroups, {deleted: false})
    if (_.isEmpty(validAccessGroups)) {
        return ''
      }

    return _.map(validAccessGroups, 'name').join(', ')
}

const state = {
    endpoints: [],
    accessGroups: [],
    activeAccessGroup: {},
    activeAccessGroupOriginal: {},
    pagination: {
        rowsPerPage: 10,
        sortBy: ["updatedDate"],
        descending: true,
        page: 1,
        totalItems: 0,
        stored: true
    },
    agPagination: {
        rowsPerPage: 10,
        sortBy: ["updatedDate"],
        descending: true,
        page: 1,
        totalItems: 0,
        stored: true
    }
}
const getters = {
    activeEndpoints(state) { return state.endpoints; },
    accessGroups(state) { return _.sortBy(state.accessGroups, (item) => item.name.toLowerCase()); },
    activeAccessGroup(state) { return state.activeAccessGroup },
    getPagination: (state) => {
        return state.pagination
    },
    getAgPagination: (state) => {
        return state.agPagination
    }
}

const mutations = {
    initialize(state) {
        Vue.set(state, 'pagination', {stored: true, rowsPerPage: 10,sortBy: ["updatedDate"],descending: true, page: 1, totalItems: 0})
        Vue.set(state, 'agPagination', {stored: true, rowsPerPage: 10,sortBy: ["updatedDate"],descending: true, page: 1, totalItems: 0})
        Vue.set(state, 'endpoints', [])
        Vue.set(state, 'accessGroups', [])
        Vue.set(state, 'activeAccessGroup', [])
        Vue.set(state, 'activeAccessGroupOriginal', [])
    },
    setPagination(state, pagination) {
        Vue.set(state, 'pagination', pagination)
    },
    setAgPagination(state, pagination) {
        Vue.set(state, 'agPagination', pagination)
    },
    setEndpoints(state, endpoints) {
      Vue.set(state, 'endpoints', endpoints)
    },
    setAccessGroups(state, accessGroups) {
      Vue.set(state, 'accessGroups', accessGroups)
    },
    setActiveAccessGroup(state, accessGroup) {
        Vue.set(state, 'activeAccessGroup', accessGroup)
    },
    setActiveAccessGroupOriginal(state, accessGroup) {
        Vue.set(state, 'activeAccessGroupOriginal', accessGroup)
    },
    updateEndpoint(state, endpoint) {
      let index = _.findIndex(state.endpoints, {id: endpoint.id})
      Vue.set(state.endpoints, index, endpoint)
    }
}

const actions = {
    initialize ({commit}) {
        commit('initialize')
    },
    setPagination({commit}, pagination) {
        commit('setPagination', pagination)
    },
    setAgPagination({commit}, pagination) {
        commit('setAgPagination', pagination)
    },
    async getAllEndpointsOnly({ commit, rootGetters, dispatch }) {
        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Fetching endpoints (only)"}, {root: true})

            response = await EndpointService.getEndpoints(false)

            commit('setEndpoints', response.data)
            dispatch('status/setStatus', {inProgress: false, operation: "Endpoints (only) refreshed", success: true, logAction: 'listing-endpoints-only'}, {root: true})
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error fetching endpoints (only)", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-listing-endpoints'}, {root: true})
        }
    },
    async getAllEndpointsWithStatuses({ commit, rootGetters, dispatch }) {
        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Fetching endpoints"}, {root: true})

            response = await EndpointService.getEndpoints(false)

            let stauses = []
            const modules = rootGetters['user/getModulesDictionary']
            if (modules && modules.Assurance) {
                let statusResponse = await EndpointService.getEndpointStatuses()
                stauses = statusResponse.data || []
            }

            _.each(response.data, (endpoint) => {
                endpoint.accessGroupSummary = buildAccessGroupsSummary(endpoint.accessGroups)
                endpoint.accessGroupString = buildAccessGroupsString(endpoint.accessGroups)
                let status = _.find(stauses, {endpoint_id: endpoint.id})
                if (status) {
                    endpoint.status = status.epm_status
                    endpoint.statusTime = status.time
                }
            })

            commit('setEndpoints', response.data)
            dispatch('status/setStatus', {inProgress: false, operation: "Endpoints refreshed", success: true, logAction: 'listing-endpoints'}, {root: true})
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error fetching endpoints", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-listing-endpoints'}, {root: true})
        }
    },
    async getEndpoint({ commit, rootGetters, dispatch }, id) {
        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Fetching endpoint details"}, {root: true})
            response = await EndpointService.getEndpoint(id)
            dispatch('status/setStatus', {inProgress: false, operation: "Endpoint details loaded", success: true, logAction: 'getting-endpoint-details'}, {root: true})
            return response.data
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error fetching endpoint details", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-getting-endpoint-details'}, {root: true})
            return null
        }
    },
    async getAllAccessGroups({ commit, rootGetters, dispatch }) {
        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Fetching monitoring groups"}, {root: true})

            response = await EndpointService.getAllAccessGroups(false)

            _.forEach(response.data, (ag) => {
                if (!ag.userCount) {
                    ag.userWithCount = ''
                } else {
                    ag.userWithCount = ag.users[0].login

                    if (ag.userCount > 1) {
                        ag.userWithCount += " (+" + (ag.userCount - 1) + " more)"
                    }
                }
            })

            commit('setAccessGroups', response.data)

            dispatch('status/setStatus', {inProgress: false, operation: "Monitoring groups refreshed", success: true, logAction: 'listing-monitoring-groups'}, {root: true})
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error fetching monitoring groups", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-listing-monitoring-groups'}, {root: true})
            return
        }
    },
    async addEndpoint({rootGetters, dispatch}, endpoint) {
        let response
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Adding endpoint"}, {root: true})

            var newEndpoint = Object.assign({}, endpoint)
            newEndpoint.id = null

            response = await EndpointService.saveEndpoint(newEndpoint)

            if (response && (response.status === 200)) {
                endpoint.id = response.data.id
                dispatch('status/setStatus', {inProgress: false, operation: "Endpoint added", success: true, logAction: 'adding-endpoint'}, {root: true})
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error adding endpoint", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-adding-endpoint'}, {root: true})
                alert('Error adding endpoint ' + response.status + ' ' + response.statusText)
                return false
            }
        } catch (ex) {
            console.error(ex)
            const errMsg = Common.getErrorMessage(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error adding endpoint", failure: true, message: errMsg, logAction: 'error-adding-endpoint'}, {root: true})
            alert('Error adding endpoint ' + errMsg)
            return false
        }
    },
    async updateEndpoint({commit, rootGetters, dispatch}, {endpoint, pwd}) {
        let response
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Updating endpoint"}, {root: true})
            response = await EndpointService.saveEndpoint(endpoint, pwd)
            if (response && (response.status === 200)) {
                commit('updateEndpoint', response.data)
                dispatch('status/setStatus', {inProgress: false, operation: "Endpoint updated", success: true, logAction: 'updating-endpoint'}, {root: true})
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error updating endpoint", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-updating-endpoint'}, {root: true})
                alert('Error updating endpoint ' + response.status + ' ' + response.statusText)
                return false
            }
        } catch (ex) {
            const errMsg = Common.getErrorMessage(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error updating endpoint", failure: true, message: errMsg, logAction: 'error-updating-endpoint'}, {root: true})
            alert('Error updating endpoint ' + errMsg)
            console.error(ex)
            return false
        }
    },
    async deleteEndpoint({commit, rootGetters, dispatch}, endpoint) {
        endpoint.deleted = true
        let response
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Deleting endpoint"}, {root: true})
            response = await EndpointService.saveEndpoint(endpoint, false)
            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "Endpoint deleted", success: true, logAction: 'deleting-endpoint'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error deleting endpoint", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-deleting-endpoint'}, {root: true})
            }
            dispatch('getAllEndpointsWithStatuses')
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error deleting endpoint", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-deleting-endpoint'}, {root: true})
            console.error(ex)
        }
    },
    async deleteEndpoints({commit, rootGetters, dispatch}, endpoints) {
        const patchlist = _.map(endpoints, (ep) => { return {id: ep.id, deleted: true}})
        let response = await EndpointService.patchMultiple(patchlist)
        return response.status === 200
    },
    async getAccessGroup({commit, rootGetters, dispatch}, accessGroupId) {
        let response
        try {

            if (!accessGroupId) {
                const newAccessGroup = {
                    id: null,
                    endpoints:[],
                    users:[],
                    deleted: false,
                    default: false,
                    endpointCount: 0,
                    userCount: 0,
                    name: ''
                }
                commit('setActiveAccessGroup', newAccessGroup)
                commit('setActiveAccessGroupOriginal', Common.deepcopy(newAccessGroup))
                return
            }

            dispatch('status/setStatus', {inProgress: true, operation: "Fetching monitoring group details"}, {root: true})
            commit('setActiveAccessGroup', {})
            response = await EndpointService.getAccessGroup(accessGroupId)
            if (response && (response.status === 200)) {
                commit('setActiveAccessGroup', response.data)
                commit('setActiveAccessGroupOriginal', Common.deepcopy(response.data))
                dispatch('status/setStatus', {inProgress: false, operation: "Monitoring group details loaded", success: true, logAction: 'getting-monitoring-group-details'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error fetching monitoring group details", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-getting-monitoring-group-details'}, {root: true})
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error fetching monitoring group details", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-getting-monitoring-group-details'}, {root: true})
            console.error(ex)
            return
        }
    },
    resetActiveAccessGroupUsers({state}) {
        let source = state.activeAccessGroupOriginal.users
        let target = state.activeAccessGroup.users

        target.splice(0, target.length, ...source)
        //commit('setActiveAccessGroup', state.activeAccessGroup)
    },
    resetActiveAccessGroupEndpoints({state}) {
        let source = state.activeAccessGroupOriginal.endpoints
        let target = state.activeAccessGroup.endpoints
        // console.log(source.length)
        target.splice(0, target.length, ...source)
        //commit('setActiveAccessGroup', state.activeAccessGroup)
    },
    async saveAccessGroup({state, commit, rootGetters, dispatch}, accessGroup) {
        let response
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Saving monitoring group"}, {root: true})
            if (accessGroup.default) {
                let accessGroupToUndefault = _.find(state.accessGroups, {default: true})
                // console.dir(accessGroupToUndefault)
                if (accessGroupToUndefault && accessGroupToUndefault.id !== accessGroup.id) {
                    accessGroupToUndefault.default = false
                    await EndpointService.saveAccessGroup(accessGroupToUndefault)
                }
            }
            
            const accessGroupToSave = Common.deepcopy(accessGroup)
            if (!_.isEmpty(accessGroupToSave.endpoints)) {
                accessGroupToSave.endpoints = _.map(accessGroupToSave.endpoints, (ep) => { return {id: ep.id}})
            }

            response = await EndpointService.saveAccessGroup(accessGroupToSave)

            if (response && (response.status === 200)) {
                commit('setActiveAccessGroup', response.data)
                commit('setActiveAccessGroupOriginal', Common.deepcopy(response.data))
                dispatch('status/setStatus', {inProgress: false, operation: "Monitoring group saved", success: true, logAction: 'updating-monitoring-group'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error saving monitoring group", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-updating-monitoring-group'}, {root: true})
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving monitoring group", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-updating-monitoring-group'}, {root: true})
            console.error(ex)
            return
        }
    },
    async deleteAccessGroup({commit, rootGetters, dispatch}, accessGroup) {
        let response
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Deleting monitoring group"}, {root: true})

            response = await EndpointService.getAccessGroup(accessGroup.id)

            let ag = response.data

            ag.deleted = true

            response = await EndpointService.saveAccessGroup(ag)
            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "Monitoring group deleted", success: true, logAction: 'deleting-monitoring-group'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error deleting monitoring group", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-deleting-monitoring-group'}, {root: true})
            }

            await dispatch('getAllAccessGroups')
            // commit('setActiveAccessGroup', response.data)
            // commit('setActiveAccessGroupOriginal', Common.deepcopy(response.data))
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error deleting monitoring group", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-deleting-monitoring-group'}, {root: true})
            console.error(ex)
            return
        }
    },
    setupNewAccessGroup({commit}) {
        let newAccessGroup = { name: '', description: '', users: [], endpoints: [] }
        commit('setActiveAccessGroup', newAccessGroup)
        commit('setActiveAccessGroupOriginal', Common.deepcopy(newAccessGroup))
    },
    async setBulkPassword({commit, state, rootGetters, dispatch}, { endpointIds, newLogin, newPassword }) {
        let response
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Applying new credentials to " + endpointIds.length + " endpoints"}, {root: true})

            const patchlist = _.map(endpointIds, (epId) => { return {id: epId, login: newLogin, password: newPassword}})

            response = await EndpointService.patchMultiple(patchlist)
            if (response && (response.status === 200)) {
                var successful = _.filter(response.data, x => x === 200).length;
                var op = successful + " endpoints updated";
                var failed = _.filter(response.data, x => x !== 200).length;
                if (failed > 0) {
                    op = op + " and " + failed + " failed to update"
                }
                dispatch('status/setStatus', {inProgress: false, operation: op, success: true, logAction: 'setting-bulk-passwords'}, {root: true})
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error updating endpoint credentials", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-setting-bulk-passwords'}, {root: true})
                return false
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error updating endpoint credentials", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-setting-bulk-passwords'}, {root: true})
            console.error(ex)
            return false
        }
    },
    async validateEndpoint({rootGetters, dispatch}, endpoint) {

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Validating endpoint"}, {root: true})

            let response = await EndpointService.validateEndpointById(endpoint.id, false)

            const result = Common.getValidationResult(response)

            if (result.success) {
                dispatch('status/setStatus', {inProgress: false, operation: "Endpoint validated", success: true, logAction: 'validating-endpoint'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error validating endpoint", failure: true, message: result.message, logAction: 'error-validating-endpoint' }, {root: true})
            }

            return result

        } catch (ex) {

            let errMsg = Common.getErrorMessage(ex)
            if (ex.response && (ex.response.status === 404)) {
                errMsg = "Please make sure a collector is running"
            }
            console.error(ex)

            dispatch('status/setStatus', {inProgress: false, operation: "Error validating endpoint", failure: true, message: errMsg, logAction: 'error-validating-endpoint'}, {root: true})

            return {success: false, message: errMsg}
        }

    },
    async getDeletedEndpoints() {
        let response = await EndpointService.getEndpoints(true)
        return response.data
    },
    async unDeleteEndpoint({}, endpoint) {
        endpoint.deleted = false
        let response = await EndpointService.saveEndpoint(endpoint, false)
        return response.status === 200
    },
    async unDeleteMultipleEndpoints({}, endpoints) {
        const patchlist = _.map(endpoints, (ep) => { return {id: ep.id, deleted: false}})
        let response = await EndpointService.patchMultiple(patchlist)
        return response.status === 200
    },
    async getDeletedAccessGroups() {
        let response = await EndpointService.getAllAccessGroups(true)
        return response.data
    },
    async unDeleteAccessGroup({}, accessGroup) {
        accessGroup.deleted = false
        let response = await EndpointService.saveAccessGroup(accessGroup)
        return response.status === 200
    },
    async unDeleteMultipleAccessGroups({}, accessGroups) {
        const patchlist = _.map(accessGroups, (ep) => { return {id: ep.id, deleted: false}})
        let response = await EndpointService.patchMultipleAccessGroups(patchlist)
        return response.status === 200
    },
    async configureXapiAdminAccounts({}, {accessGroupId, xapiAdminProps}) {
        let response = await EndpointService.configureXapiAdminAccounts(accessGroupId, xapiAdminProps)
        return response.data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
